import React from 'react';
import { motion } from 'framer-motion';
import { Award, Clock, Globe, Users } from 'lucide-react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { appConfig } from '../../config/appConfig';

const HappyTravelers: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  const stats = [
    { number: `${appConfig.metrics.happyTravelers}+`, label: 'Happy Travelers', icon: Users },
    { number: `${appConfig.metrics.destinationCount}+`, label: 'Destinations', icon: Globe },
    { number: '⭐'.repeat(appConfig.metrics.averageRating), label: 'Ratings', icon: Award },
    { number: `${new Date().getFullYear() - appConfig.metrics.establishedYear}+`, label: 'Years Experience', icon: Clock },
  ];

  return (
    <section ref={ref} className="pt-lg pb-2xl md:pb-3xl bg-neutral-white">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="gradient-primary rounded-2xl p-8 text-white">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  className="space-y-3"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={isVisible ? { opacity: 1, scale: 1 } : {}}
                  transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
                >
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white bg-opacity-20 rounded-full">
                    <stat.icon size={24} />
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-accent-champagne">
                      {stat.number}
                    </div>
                    <div className="body-small opacity-90">
                      {stat.label}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HappyTravelers;
